import { useEffect, useRef, useState } from "react";
import classes from "./PayHero.module.css";
import Spinner from "../Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../login/Header";
import { useForm, SubmitHandler } from "react-hook-form";
import Modal from "react-bootstrap/Modal";

import video from "../../assests/videos/background.mp4";
import { LahzaRequestPayDTO } from "../../types/Applicant/LahzaRequestDto";
import { AvailableApplicationsAPI } from "../../API/Applications/AvailableApplicationsAPI";
import { ApplicationTypeDto } from "../../types/Applicant/ApplicationTypeDto";

const PayHero = () => {
  const [paymentUrl, setPaymentUrl] = useState<string>("");
  const iframeRef = useRef(null);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Verify the origin
      if (event.origin !== "https://checkout.lahza.io") return;
      try {
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data != null && data.status != null) {
          if (data.status === "success") {
            navigate("/?msg=paid");
          }
        }
      } catch (err) {}
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const COMMISSION_PERCENTAGE = 1.02575;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [price, setPrice] = useState<number>();
  const [currency, setCurrency] = useState<String>("");

  const [msg, setMsg] = useState<string>("");
  const [isloading, setIsloading] = useState<boolean>(false);
  const [open, isOpen] = useState<boolean>(true);

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    navigate("/");
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LahzaRequestPayDTO>();

  const formatCurrency = (value: string) => {
    return value
      ? parseFloat(value).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "-";
  };

  const truncateTo2Decimals = (value: number): number => {
    return Math.floor(value * 100) / 100;
  };

  const onSubmit: SubmitHandler<LahzaRequestPayDTO> = async (data) => {
    setIsloading(true);
    const availableAppliications = new AvailableApplicationsAPI();
    const response =
      availableAppliications.GetInitTransactionForNewIntake(data);
    const getUrl = (await response).result.authorization_url;
    setPaymentUrl(getUrl ?? "");
    handleOpenModal();
  };

  return (
    <header className={classes.header}>
      <video autoPlay muted loop className={classes.video}>
        <source src={video} type="video/mp4" media="(min-width: 65rem)" />
      </video>
      <div className={classes.bg}></div>
      <Header dark={true} />

      {isloading ? (
        <section>
          <div className={classes.content}>
            <Spinner />
          </div>
        </section>
      ) : (
        <section>
          <div className={classes.content}>
            {open ? (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formBox">
                  <div className="formBoxHeader">
                    <div>
                      <p className={classes.titleDark}>{t("visa_title")}</p>
                      {errors.studentNo &&
                        errors.studentNo?.type === "required" && (
                          <p className="errorMessage">
                            {t("Error_Required")! + t("visa_student_no")!}
                          </p>
                        )}
                    </div>
                  </div>
                  <div className={"grid grid--2--cols"}>
                    <div>
                      <label htmlFor="material">{t("visa_student_no")!}</label>
                      <input
                        {...register("studentNo", {
                          required: true,
                        })}
                        className="textbox"
                        placeholder={t("visa_student_no")!}
                        type="textbox"
                      />
                    </div>
                  </div>
                  <div className={"grid grid--1--col"}>
                    {price != null && price != 0 ? (
                      <div className={"grid grid--2--cols"}>
                        <div>
                          <label htmlFor="price">{t("visa_price")!}</label>
                          <span id="price" dir="ltr">
                            {price} {currency}
                          </span>
                        </div>
                        <div>
                          <label htmlFor="pricecomm">
                            {t("visa_price_commession")!}
                          </label>

                          <span dir="ltr">
                            {/^\d+$/.test(price.toString())
                              ? `${formatCurrency(
                                  truncateTo2Decimals(
                                    price * COMMISSION_PERCENTAGE
                                  ).toString()
                                )} ${currency} `
                              : "—"}
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="grid grid--2--cols formBox">
                  <button
                    className="btn"
                    onClick={handleSubmit((d) => {
                      onSubmit(d);
                    })}
                  >
                    {t("visa_process")}
                  </button>
                  <button
                    className="btn goldbutton"
                    onClick={() => navigate("/")}
                  >
                    {t("visa_back_to_login_page")}
                  </button>
                </div>
              </form>
            ) : (
              <div className="grid grid--1--cols">
                <div>{msg}</div>
                <button
                  className="btn goldbutton"
                  onClick={() => navigate("/")}
                >
                  {t("visa_back_to_login_page")}
                </button>
              </div>
            )}
          </div>
        </section>
      )}

      <Modal
        show={openModal}
        onHide={handleCloseModal}
        className={classes.modal}
      >
        <Modal.Header>{t("visa_popup_title_pay")} </Modal.Header>
        <Modal.Body>
          <iframe
            src={paymentUrl}
            style={{ width: "100%", height: "700px", border: "none" }}
            title="Payment Authorization"
            ref={iframeRef}
          />
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default PayHero;
